import { FlexBox } from '@airship-platform/jam-web/components';
import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const UserDetailsFormSchema = z.object({
  firstName: z.string().min(2, 'First Name is required').max(500),
  lastName: z.string().max(500),
  title: z.string().max(500),
});

export type UserDetailsFormInputs = z.infer<typeof UserDetailsFormSchema>;

const UserDetailsInputs: React.FC = () => {
  const { control } = useFormContext<UserDetailsFormInputs>();

  return (
    <FlexBox gap={2} flexDirection={'column'} width={'100%'}>
      <FlexBox gap={[2, 1]} flexDirection={['column', 'row']} width={'100%'}>
        <Controller
          name="firstName"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="First Name"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
        <Controller
          name="lastName"
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Last Name"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              fullWidth
            />
          )}
        />
      </FlexBox>
      <Controller
        name="title"
        control={control}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label="Title"
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            fullWidth
          />
        )}
      />
    </FlexBox>
  );
};

export default UserDetailsInputs;
